import { ReloadState } from "../../types";
import { typedAction } from "../helpers";
import { TOGGLE_RELOAD } from "./actionTypes";

const initialState: ReloadState = { toggle: false };

export const toggleReload = () => {
    return typedAction(TOGGLE_RELOAD);
}

type ReloadAction = ReturnType<typeof toggleReload>;

export function reloadReducer(
    state = initialState,
    action: ReloadAction
): ReloadState {
    switch (action.type) {
        case TOGGLE_RELOAD:
            const currentToggle: boolean = state.toggle;
            return { toggle: !currentToggle };
        default:
            return state;
    }
}